<template>
<div class="content2">
  <SelectCdjProjectHeader @onHeader="onHeader">
    <el-button type="primary" size="mini" @click="exportExcel" >导出报表</el-button>
  </SelectCdjProjectHeader>

  <div class="table-wrap">
    <el-table
      v-loading="loading"
      v-if="pageData" :data="pageData.list"
      border
      style="width: 100%" height="70vh">
      <el-table-column
        align="center"
        prop="zq_region_name"
        label="战区"
        width="120" fixed>
      </el-table-column>
      <el-table-column
        align="center"
        prop="pq_region_name"
        label="片区"
        width="120" fixed>
      </el-table-column>
      <el-table-column
        align="center"
        prop="project_name"
        label="项目名称"
        width="200" fixed>
      </el-table-column>

      <el-table-column
        align="center"
        label="历史一年以上两年以内">
        <el-table-column
          align="center"
          prop="year_1_2_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="year_1_2_money"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="历史两年以上">
        <el-table-column
          align="center"
          prop="year_2_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="year_2_money"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="一年以上欠费总额">
        <el-table-column
          align="center"
          prop="year_1_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="year_1_money"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="全年诉讼计划">
        <el-table-column
          align="center"
          prop="year_ss_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="year_ss_money"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        label="1月计划">
        <el-table-column
          align="center"
          prop="month_house_count_1"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_house_money_1"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        label="2月计划">
        <el-table-column
          align="center"
          prop="month_house_count_2"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_house_money_2"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        label="3月计划">
        <el-table-column
          align="center"
          prop="month_house_count_3"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_house_money_3"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        label="4月计划">
        <el-table-column
          align="center"
          prop="month_house_count_4"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_house_money_4"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        label="5月计划">
        <el-table-column
          align="center"
          prop="month_house_count_5"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_house_money_5"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        label="6月计划">
        <el-table-column
          align="center"
          prop="month_house_count_6"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_house_money_6"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        label="7月计划">
        <el-table-column
          align="center"
          prop="month_house_count_7"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_house_money_7"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        label="8月计划">
        <el-table-column
          align="center"
          prop="month_house_count_8"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_house_money_8"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        label="9月计划">
        <el-table-column
          align="center"
          prop="month_house_count_9"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_house_money_9"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        label="10月计划">
        <el-table-column
          align="center"
          prop="month_house_count_10"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_house_money_10"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        label="11月计划">
        <el-table-column
          align="center"
          prop="month_house_count_11"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_house_money_11"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        label="12月计划">
        <el-table-column
          align="center"
          prop="month_house_count_12"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="month_house_money_12"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

    </el-table>
  </div>
  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                   :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                   @current-change="pageChange"></el-pagination>
  </div>
</div>
</template>

<script>
import SelectCdjProjectHeader from "../common/SelectCdjProjectHeader";
import {CommonHelp} from "../../common/CommonHelp";
import ButlerHttp from "../../common/ButlerHttp";
export default {
  name: "AnnualLitigationPlanForProjectsUnderManagement",
  components: {SelectCdjProjectHeader},
  data(){
    return{
      loading: false,
      reginWhere:{},
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
    }
  },
  mounted() {
    const that=this;
  },
  methods:{
    onHeader(e){
      console.log(e)
      this.reginWhere=e;
      this.pageChange(1)
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = {}
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      ButlerHttp.post("LegalStatistics/在管项目年度全年诉讼计划列表", {
        ...where,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i
      CommonHelp.debounce(function () {
        that.getList();
      },500,that);

    },
    exportExcel() {
      const that = this;
      that.loading = true;
      let where = {}
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      ButlerHttp.post("LegalStatistics/在管项目年度全年诉讼计划表", {
        ...where
      }, res => {
        if (res.code) {
          window.open(res.data);
        }
        that.loading = false;
      });
    },
    round(val,num=2) {
      return Math.round(val*100)/100
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../common";
.content2{
  background-color: #ffffff;
  //width: 100%;
  margin: 20px;
  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: flex;
    flex-direction: row;

    .header-tip-body{
      //width: 500px;
      margin-left: 50px;
      display: flex;
      flex-direction: row;
      //justify-content: space-between;
      .header-tip-body-item{
        margin-left: 50px;
        display: flex;
        flex-direction: row;
      }
    }
  }
  .pagination-wrap{
    margin-top: 10px;
    text-align: center;
  }

  >>>.el-table--border, .el-table--group{
    border: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
    border-bottom: 1px solid #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/litigation/AnnualLitigationPlanForProjectsUnderManagement.vue